<template>
    <td-dialog
        :title="$t(title)"
        append-to-body="true"
        :before-close="classDialogClose"
        :visible.sync="dialogClassVisible"
        width="810px"
        height="460px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromUser" ref="fromUser" class="demo-form-inline" :rules="rules">
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('pgCommon.CREATE_URL')">
                                        <td-input placeholder="pgCommon.PLEASE_INPUT" v-model="fromUser.url" :maxlength="200"></td-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('pgCommon.REQUEST_PARAMS_STRING')">
                                        <td-input v-model="fromUser.urlParams" :maxlength="20" placeholder="pgMessage.NOFORMAT_STRING"></td-input>
                                    </el-form-item>
                                </div>
                            </td-permission>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('pgCommon.COMPLETE_URL')">
                                        <td-input placeholder="pgCommon.PLEASE_INPUT" v-model="fromGroup.url" :maxlength="200"></td-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('pgCommon.REQUEST_PARAMS_STRING')">
                                        <td-input v-model="fromGroup.urlParams" :maxlength="20" placeholder="pgMessage.NOFORMAT_STRING"></td-input>
                                    </el-form-item>
                                </div>
                            </td-permission>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="classDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'dialogClassVisible', 'templateKey', 'classParam'],
    // 定义变量
    // 定义数据
    data() {
        return {
            fromUser: {
                url: '',
                urlParams: ''
            },
            fromGroup: {
                url: '',
                urlParams: ''
            },
            editItem: '',
            sysFlg: '',
            permissionsAdd: ['userInfo:add'],
            permissionsEdit: ['userInfo:edit'],
            permissionsView: ['userInfo:view'],
            permissionsDel: ['userInfo:del'],
            permissionsImport: ['userInfo:import'],
            permissionsExport: ['userInfo:export'],
            roles: ['admin'],
            sysList: [],
            sysAndFlgList: [],
            orgList: [],
            orgTreeUrl: '',
            dialogUploadExcelVisible: false,
            dialogUserDetailVisible: false,
            tableData: [],
            selectRows: [],
            lastSelect: [],
            userIds: [],
            userNames: [],
            currPage: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ],
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'userName',
                    label: this.$t('pgCommon.USERNAME')
                },
                {
                    prop: 'roleName',
                    label: this.$t('pgCommon.USERROLE')
                }
            ]
        };
    },
    mounted() {
        this.queryFeedBack();
    },
    // 方法的实现
    methods: {
        // 保存
        save: function() {
            let param = {
                processDefKey: this.templateKey,
                userIds: this.fromUser.url,
                userNames: this.fromUser.urlParams,
                roleIds: this.fromGroup.url,
                roleNames: this.fromGroup.urlParams,
                flag: this.classParam.tasksFlag,
                proDefId: this.templateKey + ':TEMP'
            };
            if (this.classParam.taskType == 'ServiceTask') {
                param.sId = this.templateKey + this.classParam.taskKey + 'DelegateCreate';
                param.taskDefKey = this.classParam.taskKey + 'Delegate';
            } else if (this.classParam.taskType == 'UserTask') {
                param.sId = this.templateKey + this.classParam.taskKey + 'ListenerCreate';
                param.taskDefKey = this.classParam.taskKey + 'Listener';
            }
            Api.saveNodeUser(JSON.stringify(param), response => {
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.loading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.classDialogClose();
            });
        },
        // 查询回显数据
        queryFeedBack() {
            this.loading = true;
            let param = {
                sId: this.templateKey + this.classParam.taskKey + 'ListenerCreate',
                processDefKey: this.templateKey,
                taskDefKey: this.classParam.taskKey + 'Listener',
                proDefId: this.templateKey + ':TEMP'
            };
            if (this.classParam.taskType == 'ServiceTask') {
                param.sId = this.templateKey + this.classParam.taskKey + 'DelegateCreate';
                param.taskDefKey = this.classParam.taskKey + 'Delegate';
            } else if (this.classParam.taskType == 'UserTask') {
                param.sId = this.templateKey + this.classParam.taskKey + 'ListenerCreate';
                param.taskDefKey = this.classParam.taskKey + 'Listener';
            }
            Api.queryNodeUser(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('queryNodeUser', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryNodeUser', response.data.statusMessage);
                    return;
                }
                if (response.data.content.length > 0) {
                    this.fromUser.url = response.data.content[0].userIds;
                    this.fromUser.urlParams = response.data.content[0].userNames;
                }
                if (response.data.content.length > 0) {
                    this.fromGroup.url = response.data.content[0].roleIds;
                    this.fromGroup.urlParams = response.data.content[0].roleNames;
                }
            });
        },
        classDialogClose: function() {
            this.$emit('classDialogClose');
            this.dialogClassVisible = false;
        }
    }
};
</script>
